import { Component, OnInit, HostListener, Renderer2, ElementRef, Injector } from "@angular/core";
import { NavigationService, IMenuItem, IChildItem } from "../../../../services/navigation.service";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { filter } from "rxjs/operators";
import { Utils } from "../../../../utils";
import { DefaultSettingService } from "@shared/services/default-setting.service";
import { TourService } from "ngx-ui-tour-md-menu";
import { AppComponentBase } from "@shared/app-component-base";

@Component({
  selector: "app-sidebar-large",
  templateUrl: "./sidebar-large.component.html",
  styleUrls: ["./sidebar-large.component.scss"],
})
export class SidebarLargeComponent extends AppComponentBase implements OnInit {
  selectedItem: IMenuItem;

  nav: IMenuItem[];

  searchWord: string = "";

  onSearchInputChange() {
    this.navService.filterMenu(this.searchWord);

    if (this.selectedItem && this.selectedItem.sub) {
      const foundInSubmenu = this.selectedItem.sub.some(
        (subItem) => subItem.active
      );
      if (foundInSubmenu) {
        this.navService.sidebarState.childnavOpen = true;
      } else {
        this.navService.sidebarState.childnavOpen = false;
      }
    } else {
      this.navService.sidebarState.childnavOpen = false;
    }
  }

  clearSearch() {
    this.searchWord = "";
    this.onSearchInputChange();
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.closeChildNav();
    }
  }

  constructor(
    injector:Injector,
    public router: Router,
    public navService: NavigationService,
    private _defaultSettingsService:DefaultSettingService,
    private tourService:TourService,
    private steps:TourService,
    private route:ActivatedRoute,
    private renderer: Renderer2,
) {
    super(injector);
}

  arLang = false;

  ngOnInit() {
    this._defaultSettingsService.tourEnded$.subscribe(res=>{

      if(res == "sidebar"){
          this.tourService.initialize([{
              anchorId: '6',
              content: this.l('YouCanViewTheMenuInThisSectionClickOnTheMenuForMoreDetails'),
              title: this.l('Menu'),
              enableBackdrop: true,
              prevBtnTitle:this.l('Previous'),
              nextBtnTitle:this.l('Next'),
              endBtnTitle:this.l('Done'),
              // placement: 'right',
              closeOnOutsideClick: true,
              nextStep: '7',
              prevStep: '5'
            }
          ]);
          this.tourService.start();
      }
  })
  

  this.tourService.events$.subscribe(res=>{
      
      if(res.name =="end" && !this.tourService.hasNext(this.tourService.currentStep)){
           console.log("sidebar")
          this._defaultSettingsService.tourSendNext("header-sidebar");
      }
  })
    this.updateSidebar();
    // CLOSE SIDENAV ON ROUTE CHANGE

    this.arLang =
      abp.utils.getCookieValue("Abp.Localization.CultureName") == "ar"
        ? true
        : false;

    if (this.arLang) {
      this.renderer.setAttribute(document.body, "dir", "rtl");
    }

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((routeChange) => {
        this.closeChildNav();
        if (Utils.isMobile()) {
          this.navService.sidebarState.sidenavOpen = false;
        }
      });

    this.navService.menuItems$.subscribe((items) => {
      this.nav = items;
      this.setActiveFlag();
    });
  }

  selectItem(item) {
    if (
      item != this.selectedItem ||
      !this.navService.sidebarState.childnavOpen
    ) {
      this.navService.sidebarState.childnavOpen = true;
      this.selectedItem = item;
      this.setActiveMainItem(item);
    } else {
      this.closeChildNav();
    }
  }
  closeChildNav() {
    this.navService.sidebarState.childnavOpen = false;
    this.setActiveFlag();
  }

  onClickChangeActiveFlag(item) {
    this.setActiveMainItem(item);
  }
  setActiveMainItem(selectedItem) {
    this.nav.forEach((item) => {
      item.active = false;
    });
    selectedItem.active = true;
  }

  setActiveFlag() {
    if (window && window.location) {
      const activeRoute = window.location.hash || window.location.pathname;
      this.nav.forEach((item) => {
        if (item == this.selectedItem) {
          item.active = false;
          if (activeRoute.indexOf(item.state) !== -1) {
            this.selectedItem = item;
            item.active = true;
          }
          if (item.sub) {
            item.sub.forEach((subItem) => {
              subItem.active = false;
              if (activeRoute.indexOf(subItem.state) !== -1) {
                this.selectedItem = item;
                item.active = true;
              }
              if (subItem.sub) {
                subItem.sub.forEach((subChildItem) => {
                  if (activeRoute.indexOf(subChildItem.state) !== -1) {
                    this.selectedItem = item;
                    item.active = true;
                    subItem.active = true;
                  }
                });
              }
            });
          }
        } else {
          item.active = false;
        }
      });
    }
  }

  updateSidebar() {
    if (Utils.isMobile()) {
      this.navService.sidebarState.sidenavOpen = false;
      this.navService.sidebarState.childnavOpen = false;
    } else {
      this.navService.sidebarState.sidenavOpen = true;
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.updateSidebar();
  }
  a(item) {
    console.log(item);
  }
}
